import {PageDescription} from './page-description';
import {CCRoles} from '../../model/security/cc-roles-type';
import {AsbCCUrl} from './abs-cc-url';

export class CrystalClearFrontUrl extends AsbCCUrl {
  static readonly ROOT: PageDescription = {label: 'page_title.welcome', path: '', roles: CCRoles.ROLES_ALL};
  static readonly LOGIN: PageDescription = {label: 'page_title.login', path: 'login', roles: CCRoles.ROLES_ALL};
  static readonly HOME: PageDescription = {label: 'page_title.home', path: 'home', roles: CCRoles.ROLES_ALL};
  static readonly ABOUT: PageDescription = {label: 'page_title.about', path: 'about', roles: CCRoles.ROLES_ALL};
  static readonly SUPPORT: PageDescription = {
    label: 'page_title.support',
    path: 'about/support',
    roles: CCRoles.ROLES_ALL
  };
  static readonly VERSION: PageDescription = {
    label: 'page_title.version',
    path: 'about/version',
    roles: CCRoles.ROLES_ALL
  };
  static readonly TRADES_ORDERS: PageDescription = {
    label: 'page_title.trades_orders',
    path: 'trades_orders',
    icon: 'fa fa-landmark icon-only',
    roles: CCRoles.ROLES_CLEARING
  };
  static readonly CLEARING_FLEX_REQUEST: PageDescription = {
    label: 'page_title.clearing_flex_request',
    icon: 'fas fa-keyboard flex_request_icon',
    roles: CCRoles.ROLES_CLEARING_FLEX_REQUEST
  };
  static readonly CLEARING_FLEX_ORDER_REQUEST: PageDescription = {
    label: 'page_title.clearing_flex_order_request',
    roles: CCRoles.ROLES_CLEARING_FLEX_REQUEST
  };
  static readonly CLEARING_FLEX_TRADE_REQUEST: PageDescription = {
    label: 'page_title.clearing_flex_trade_request',
    roles: CCRoles.ROLES_CLEARING_FLEX_REQUEST
  };
  // ORDERS_POF
  static readonly ORDERS_POF: PageDescription = {
    label: 'page_title.orders_pof',
    path: 'orders_pof',
    icon: 'fa fa-landmark',
    roles: CCRoles.ROLES_CLEARING_POF
  };
  // ARCHIVE
  static readonly ARCHIVE_REPORT_FORM: PageDescription = {
    label: 'page_title.archive.form',
    path: 'archive/form',
    icon: 'fa fa-archive',
    roles: CCRoles.ROLES_ARCHIVE_FORM
  };
  static readonly ARCHIVE_REPORT_PROFILE: PageDescription = {
    label: 'page_title.archive.profile',
    path: 'archive/profiles',
    icon: 'fas fa-sliders',
    roles: CCRoles.ROLES_ARCHIVE_EXPORT_PROFILE
  };
  static readonly ARCHIVE_REPORT_TASKS: PageDescription = {
    label: 'page_title.archive.tasks',
    path: 'archive/tasks',
    icon: 'fas fa-list-check',
    roles: CCRoles.ROLES_ARCHIVE_REPORT_TASKS
  };
  static readonly ARCHIVE_RECAP_FORM: PageDescription = {
    label: 'page_title.recap.form',
    path: 'recap/form',
    icon: 'fa fa-archive',
    roles: CCRoles.ROLES_RECAP_FORM
  };
  static readonly ARCHIVE_RECAP_PROFILE: PageDescription = {
    label: 'page_title.recap.profile',
    path: 'recap/profiles',
    icon: 'fas fa-envelope-circle-check',
    roles: CCRoles.ROLES_ARCHIVE_RECAP_PROFILE
  };
  static readonly ARCHIVE_RECAP_LIST: PageDescription = {
    label: 'page.profile.recap.list.title',
    icon: 'fas fa-envelope-circle-check',
    roles: CCRoles.ROLES_RECAP_LIST
  };
  static readonly ARCHIVE_RECAP_TASKS: PageDescription = {
    label: 'page_title.recap.tasks',
    path: 'recap/tasks',
    icon: 'fas fa-list-check',
    roles: CCRoles.ROLES_ARCHIVE_RECAP_TASKS
  };
  // BILLING
  static readonly ARCHIVE_BILLING_LIST: PageDescription = {
    label: 'page_title.billing.list',
    path: 'billing/list',
    icon: 'fa fa-file-invoice-dollar',
    roles: CCRoles.ROLES_BILLING_LIST
  };
  static readonly ARCHIVE_INVOICE_TASKS: PageDescription = {
    label: 'page_title.billing.tasks',
    path: 'invoice/tasks',
    icon: 'fas fa-list-check',
    roles: CCRoles.ROLES_BILLING_LIST
  };
  //DATA AMENDMENT
  static readonly DATAAMENDMENT_ORDER_LIST: PageDescription = {
    label: 'page_title.order-amendment.title',
    icon: 'fas fa-square-pen',
    roles: CCRoles.ROLES_AMEND_ORDER
  };
  // SECURITY
  static readonly SECURITY_USER: PageDescription = {
    label: 'page_title.security.user',
    path: 'security/user',
    roles: CCRoles.ROLES_SECURITY,
    icon: 'fa fa-users-cog'
  };
  static readonly SECURITY_USER_GROUP: PageDescription = {
    label: 'page_title.security.user-group',
    path: 'security/user-group',
    roles: CCRoles.ROLES_SECURITY,
    icon: 'fa fa-people-group'
  };
  // CONFIG
  static readonly CONFIG: PageDescription = {
    label: 'page_title.configuration',
    roles: CCRoles.ROLES_CONFIG,
    icon: 'fas fa-cogs'
  };
  static readonly URLS: PageDescription[] = [
    CrystalClearFrontUrl.LOGIN,
    CrystalClearFrontUrl.HOME,
    CrystalClearFrontUrl.ABOUT,
    CrystalClearFrontUrl.SUPPORT,
    CrystalClearFrontUrl.VERSION,
    CrystalClearFrontUrl.TRADES_ORDERS,
    CrystalClearFrontUrl.ORDERS_POF,
    CrystalClearFrontUrl.ARCHIVE_REPORT_FORM,
    CrystalClearFrontUrl.ARCHIVE_REPORT_PROFILE,
    CrystalClearFrontUrl.ARCHIVE_RECAP_PROFILE,
    CrystalClearFrontUrl.SECURITY_USER,
    CrystalClearFrontUrl.SECURITY_USER_GROUP,
  ];

}
